import React, { useEffect, useState } from 'react';
import { Grid, TextField } from '@mui/material';
import { useLang } from '~/hooks/useLang';
import { UseFormGetValues, UseFormRegister, Controller, type UseFormSetValue, type UseFormWatch } from 'react-hook-form';
import InputMask from 'react-input-mask';

interface CrudTextFieldProps {
  readonly register: UseFormRegister<any>;
  readonly getValues?: UseFormGetValues<any>;
  readonly setFormValue?: UseFormSetValue<any>
  readonly watch?: UseFormWatch<any>
  readonly model: string;
  readonly mask?: any | undefined;
  readonly passwd?: boolean;
  readonly control?: any;
  readonly placeholder?: string;
  readonly required?: boolean;
  readonly readonly?: boolean;
  readonly color?: boolean;
}

export default function CrudTextField(props: CrudTextFieldProps) {
  const { translate } = useLang();
  const { register, model, mask, getValues, setFormValue, passwd = false, control, placeholder, required = false, readonly = false, watch, color = false } = props;
  const registeredModelFormField = register(model);
  const Input = InputMask as any;
  return (
    <Grid item xs={4}>
      {mask ?
        <Controller
          {...registeredModelFormField}
          name={model}
          control={control}
          defaultValue={(getValues && getValues(model)) ?? ''}
          render={(props) => {
            return (
              <Input
                {...props.field}
                mask={`${mask}`}
                value={props.field.value}
                maskChar="_"
              >
                <TextField
                  fullWidth
                  label={translate(`${placeholder ? placeholder.charAt(0).toUpperCase() + placeholder.slice(1) : model.charAt(0).toUpperCase() + model.slice(1)}`)}
                  margin='normal'
                  defaultValue={(getValues && getValues(model)) ?? ''}
                  sx={{ mt: 0 }}
                  InputLabelProps={{
                    shrink: (props.field.value ?? ''),
                  }}
                  required={required}
                />
              </Input>
            )
          }
          }
        />
        :
        <TextField
          {...registeredModelFormField}
          label={translate(`${placeholder ? placeholder.charAt(0).toUpperCase() + placeholder.slice(1) : model.charAt(0).toUpperCase() + model.slice(1)}`)}
          margin='normal'
          fullWidth
          type={passwd ? 'password' : color ? 'color' : 'text'}
          defaultValue={(getValues && getValues(model)) ?? ''}
          sx={{ mt: 0, width: color ? '25%' : '100%' }}
          InputLabelProps={{
            // shrink: (getValues && getValues( model )),
            shrink: true,
          }}
          required={required}
          error={false}
          disabled={readonly}
        />
      }
    </Grid>
  )
}

